import {ComponentUpdater} from './index'

export const SimpleUpdater = (
  updateSaver: (update: () => void) => void,
  onUnmount?: () => void
) => {
  return {
    displayName: 'EventBusUpdater',
    onMount: update => {
      updateSaver(update)
    },
    onUnmount: () => {
      if (onUnmount) {
        onUnmount()
      }
    }
  } as ComponentUpdater
}
